import Nav from '../components/shared/Nav';
import Footer from '../components/shared/Footer';
import Hero from '../components/home/Hero';
import ProductTour from '../components/home/ProductTour';
import StatsStrip from '../components/home/StatsStrip';
import ProductsDuo from '../components/home/ProductsDuo';
import About from '../components/home/About';
import ClientGrid from '../components/home/ClientGrid';
import CTA from '../components/home/CTA';

export default function HomePage() {
  return (
    <div data-screen-label="01 Home">
      <Nav current="home" />
      <Hero />
      <ProductTour />
      <StatsStrip />
      <ProductsDuo />
      <About />
      <ClientGrid />
      <CTA />
      <Footer />
    </div>
  );
}
